import React from 'react'
import {
    StyledTWStaticAFLCard,
    StyledTWStaticAFLCardHeading,
    StyledTWStaticAFLCardText,
    StyledTWStaticAFLCardTextWrapper,
} from './TWStaticAFLCard.styled'

export const TWStaticAFLCard = () => {
    return (
        <StyledTWStaticAFLCard>
            <StyledTWStaticAFLCardTextWrapper>
                <StyledTWStaticAFLCardHeading>
                    Who are WA's top draft prospects?
                </StyledTWStaticAFLCardHeading>
                <StyledTWStaticAFLCardText>
                    See video highlights, stats and profiles for our 25 leading
                    draftee contenders.
                </StyledTWStaticAFLCardText>
            </StyledTWStaticAFLCardTextWrapper>
        </StyledTWStaticAFLCard>
    )
}
